var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyDiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.804,
    height: 12,
    viewBox: "0 0 10.804 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#43425d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.608,0H1.8A2.2,2.2,0,0,0,.626.4,1.532,1.532,0,0,0,0,1.8v8.4a1.532,1.532,0,0,0,.626,1.4A2.2,2.2,0,0,0,1.8,12h9V10.8H1.815a.989.989,0,0,1-.415-.127.5.5,0,0,1-.2-.478.513.513,0,0,1,.007-.084.513.513,0,0,0,.007-.084.449.449,0,0,1,.239-.338,1.049,1.049,0,0,1,.352-.1h9V1.2a1.151,1.151,0,0,0-.352-.844A1.151,1.151,0,0,0,9.608,0Zm0,8.4H1.2V1.8a.516.516,0,0,1,.2-.485.79.79,0,0,1,.4-.12H6.007V5.4l1.2-.6,1.2.6V1.2h1.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDiary);
export default __webpack_public_path__ + "static/media/my-diary.5dac25a9b4d31f051989dd25d3949783.svg";
export { ForwardRef as ReactComponent };